import React from 'react';
import { Header } from 'components/UniversalSearch/components/Header/Header';
import { List } from 'components/UniversalSearch/components/List/List';
import { useModelsList } from 'components/UniversalSearch/components/SearchModal/useModelsList';
import { useUniversalSearchStore } from 'components/UniversalSearch/UniversalSearchStore';
import { headerWrapperStyled, contentWrapperStyled } from 'components/UniversalSearch/components/SearchModal/SearchModal.styled';
import { Spinner } from 'components/Spinner';
type SearchModalProps = {
  onClose: () => void;
};
export const SearchModal: React.FC<SearchModalProps> = ({
  onClose
}) => {
  const {
    searchParam,
    userOrOrgId
  } = useUniversalSearchStore();
  const modelsList = useModelsList({
    searchParam,
    userOrOrgId
  });
  return <>
      <div className={headerWrapperStyled}>
        <Header onClose={onClose} />
      </div>
      <div className={contentWrapperStyled}>{modelsList.loading ? <Spinner /> : <List options={modelsList.data} />}</div>
    </>;
};